import React from 'react';
import styles from './index.css';

export default ({style, em, title}) => (
<div className={styles.header} style={style}>
    {em && <div />} 
    {title}
</div>
)



// WEBPACK FOOTER //
// ./src/component/header/index.js